import { render } from "./EnergyClass.vue?vue&type=template&id=3bd4dfe8"
import script from "./EnergyClass.vue?vue&type=script&lang=js"
export * from "./EnergyClass.vue?vue&type=script&lang=js"

import "./EnergyClass.vue?vue&type=style&index=0&id=3bd4dfe8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__